import { render } from "./token.vue?vue&type=template&id=27ad7f42&scoped=true"
import script from "./token.vue?vue&type=script&lang=js"
export * from "./token.vue?vue&type=script&lang=js"

import "./token.vue?vue&type=style&index=0&id=27ad7f42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ad7f42"]])

export default __exports__